import type { TagDesignTokens } from '@primeuix/themes/types/tag'

export default {
  icon: {
    size: '0.75rem',
  },
  root: {
    gap: '0.25rem',
    padding: '0.25rem 0.5rem',
    fontSize: '0.875rem',
    fontWeight: '700',
    borderRadius: '{content.border.radius}',
    roundedBorderRadius: '{border.radius.xl}',
  },
  colorScheme: {
    dark: {
      info: {
        color: '{sky.950}',
        background: '{sky.400}',
      },
      warn: {
        color: '{orange.950}',
        background: '{orange.400}',
      },
      danger: {
        color: '{red.950}',
        background: '{red.400}',
      },
      primary: {
        color: '{primary.contrast.color}',
        background: '{primary.color}',
      },
      success: {
        color: '{green.950}',
        background: '{green.400}',
      },
      contrast: {
        color: '{surface.950}',
        background: '{surface.0}',
      },
      secondary: {
        color: '{surface.300}',
        background: '{surface.800}',
      },
    },
    light: {
      info: {
        color: '{surface.0}',
        background: '{sky.500}',
      },
      warn: {
        color: '{surface.0}',
        background: '{orange.500}',
      },
      danger: {
        color: '{surface.0}',
        background: '{red.500}',
      },
      primary: {
        color: '{primary.contrast.color}',
        background: '{primary.color}',
      },
      success: {
        color: '{surface.0}',
        background: '{green.500}',
      },
      contrast: {
        color: '{surface.0}',
        background: '{surface.950}',
      },
      secondary: {
        color: '{surface.600}',
        background: '{surface.100}',
      },
    },
  },
} satisfies TagDesignTokens
